module.exports = __webpack_public_path__ + "i18n/pt-BR.b3559e86dc176a84588a5be8249f06c5.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1545
// module chunks = 60